import { UA_PROTOCOLS, isUnityUA, resolveUaProtocol } from '@/utils/uaConfig'

const parseLanguageFromUaTag = (userAgent: string, languageTag: string, dataTag: string) => {
  const language = userAgent.match(
    new RegExp(`(${languageTag.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})\\/([\\S.]+)`)
  ) as RegExpMatchArray

  if (language && language.length > 0) {
    if (language[language.length - 1].includes(dataTag)) {
      const index = language[language.length - 1].indexOf(dataTag)
      return index !== -1 ? language[language.length - 1].substring(0, index) : 'en'
    }
    return language[language.length - 1]
  }
  return 'en'
}

/** 获取当前语言标识，兼容两套 UA 协议 */
export const getLocaleLanguage = () => {
  const userAgent = navigator.userAgent.toLowerCase()

  for (const protocol of UA_PROTOCOLS) {
    const languageTag = protocol.language.toLowerCase()
    if (userAgent.includes(languageTag)) {
      return parseLanguageFromUaTag(userAgent, languageTag, protocol.data.toLowerCase())
    }
  }

  if (isUnityUA(userAgent)) {
    const protocol = resolveUaProtocol(navigator.userAgent) ?? UA_PROTOCOLS[0]
    const language = userAgent.match(/language:([^,]+)/) as RegExpMatchArray
    if (language && language.length > 0) {
      const languageStr = language[language.length - 1]
      const unityTag = protocol.unity.toLowerCase()
      if (languageStr.includes(unityTag)) {
        const index = languageStr.indexOf(unityTag)
        return index !== -1 ? languageStr.substring(0, index) : 'en'
      }
      return languageStr
    }
    return navigator.language.toLowerCase()
  }

  return navigator.language.toLowerCase()
}
